import { BusinessError } from './businessError';

export class NotAuthorizedError extends BusinessError {
    public name = 'NotAuthorizedError';
}
